// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatStatus } from 'components/DataTable'

const columns = [{
  columnKey: 'antennaCode',
  columnHeader: 'Code',
  columnWidth: '80px',
  sortable: true,
}, {
  columnKey: 'company',
  columnHeader: 'Manuf.',
  sortable: true,
}, {
  columnKey: 'antennaFamily',
  columnHeader: 'Model Family',
  sortable: true,
}, {
  columnKey: 'modelNumberAndFeedDir',
  columnHeader: 'Model',
  sortable: true,
}, {
  columnKey: 'pol',
  columnHeader: 'Pol.',
  columnWidth: '60px',
  sortable: true,
}, {
  columnKey: 'frequencyRange',
  columnHeader: 'Freq. (MHz)',
  sortable: true,
}, {
  columnKey: 'gain',
  columnHeader: 'Gain (dBi)',
  columnWidth: '80px',
  sortable: true,
}, {
  columnKey: 'beamwidth',
  columnHeader: 'BW (°)',
  columnWidth: '80px',
  sortable: true,
}, {
  columnKey: 'diameterMandFt',
  columnHeader: 'Diameter (m/ft)',
  sortable: true,
}, {
  columnKey: 'compliance',
  columnHeader: 'Comp.',
  sortable: true,
}, {
  columnKey: 'rpeNumber',
  columnHeader: 'RPE',
  sortable: true,
}, {
  columnKey: 'patternDate',
  columnHeader: 'Pattern Date',
  sortable: true,
}, {
  cellFormatter: FormatStatus,
  columnKey: 'status',
  columnHeader: 'Status',
  columnWidth: '50px',
  sortable: true,
}]

export default columns
